import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-home-privacy-terms-body',
  templateUrl: './home-privacy-terms-body.component.html',
  styleUrls: ['./home-privacy-terms-body.component.scss']
})
export class HomePrivacyTermsBodyComponent extends BaseComponent implements OnInit {

  @Input()
  contentTranslocoKey: string;

  constructor(
    public override responsive: ResponsiveService,
    public override transloco: TranslocoService,
  ) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
  }

}
